//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormWrap from './FormAside/FormWrap'
import MtInput from '~/components/form/MtInput'
import Button from '~/components/other/Button'
import SocialLogin from '~/components/forms/SocialLogin'
import MtModal from '~/components/Modal/MtModal'

export default {
  components: {
    FormWrap,
    MtInput,
    Button,
    SocialLogin,
    MtModal
  },
  data() {
    return {
      inputValues: {
        email: '',
        password: '',
      },
      passwordRestoreModalOpened: false,
      restoreEmail: '',
      restoreSuccess: false,
      restoreError: null,
      requestingRestore: false,
      formError: null
    }
  },
  computed: {
  },
  beforeDestroy() {
    if (this.$route.query.hasOwnProperty('loginAsideOpen')) {
      this.$router.push(this.$route.path)
    }
  },
  methods: {
    submitForm() {
      const { email, password } = this.inputValues
      this.formError = null

      this.$axios({
        method: 'post',
        url: '/api/auth/',
        data: `email=${email}&password=${password}&lang=${this.$i18n.locale || 'ru'}`
      })
        .then(({data}) => {
          if (data.error) {
            this.formError = data.error.message
          } else {
            this.$cookies.set('token', data.data.token)
            this.$store.commit('sidebars/loginAsideClose')
            // this.$router.push('/profile/detail')
            window.location.href = '/app/profile/detail'
          }
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
    },
    async requestRestoration () {
      this.requestingRestore = true
      try {
        const res = await this.$axios.post('/api/getRestoreLink/', `email=${this.restoreEmail}`)

        if (res.data.status) {
          this.restoreSuccess = true
        } else {
          this.restoreError = this.$t('login.emailError')
        }
      } catch (e) {
        this.restoreError = this.$t('login.emailError')
      }
      this.requestingRestore = false
    }
  }
}
